import React, { useState, useEffect } from 'react';
import { Routes, Route, Navigate, useLocation, useNavigate } from 'react-router-dom';
import TopNav from './components/TopNav';
import Login from './components/auth/Login';
import TakeawayOrders from './pages/TakeawayOrders';
import Reservations from './pages/Reservations';
import Statistics from './pages/Statistics';
import AdminConfig from './pages/AdminConfig';
import { API_BASE_URL } from './constants/config';
import { useRefundAlerts } from './hooks/useRefundAlerts';

const AppShell = ({ token, onLogout }) => {
  // Aqui e não numa página: o aviso de um pedido de reembolso tem de se ouvir
  // em qualquer ecrã do painel.
  const pedidosReembolso = useRefundAlerts(token, API_BASE_URL);

  return (
    <>
      <TopNav onLogout={onLogout} refundRequests={pedidosReembolso} />
      <Routes>
        <Route path="/" element={<Navigate to="/takeaway" replace />} />
        <Route path="/takeaway" element={<TakeawayOrders token={token} apiUrl={API_BASE_URL} onLogout={onLogout} />} />
        <Route path="/reservations" element={<Reservations />} />
        <Route path="/statistics" element={<Statistics />} />
        <Route path="/admin" element={<AdminConfig />} />
        <Route path="*" element={<Navigate to="/takeaway" replace />} />
      </Routes>
    </>
  );
};

const App = () => {
  const [token, setToken] = useState(() => localStorage.getItem('toms_auth_token'));
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (!token && location.pathname !== '/login') {
      navigate('/login', { replace: true, state: { from: location } });
    }
  }, [token, location, navigate]);

  const handleLoginSuccess = (newToken) => {
    localStorage.setItem('toms_auth_token', newToken);
    setToken(newToken);
    const redirectPath = location.state?.from?.pathname || location.pathname || '/takeaway';
    const safeRedirect = redirectPath === '/login' ? '/takeaway' : redirectPath;
    navigate(safeRedirect, { replace: true });
  };

  const handleLogout = () => {
    localStorage.removeItem('toms_auth_token');
    setToken(null);
    navigate('/login', { replace: true });
  };

  if (!token) {
    return (
      <Routes>
        <Route path="/login" element={<Login apiUrl={API_BASE_URL} onLoginSuccess={handleLoginSuccess} />} />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    );
  }

  return <AppShell token={token} onLogout={handleLogout} />;
};

export default App;
